/* eslint-disable no-undef */
import React, {Component} from 'react'
import Base from '../BaseComponent'
import {Marker} from 'react-google-maps';
import {TweenLite,ScrollTo} from 'gsap';

import {
  withRouter
} from 'react-router-dom';

class CustomMarker extends Component {

    icons = {
        black: {
            path: "M0,15.93H3.93L1.17,0,6,4.43,10.8,0,8.13,15.93H12l-6,8.4Z",
            fillColor: '#000000',
            fillOpacity: 1,
            strokeWeight: 0,
            scale: 1
        },
        yellow: {
          path: "M0,15.93H3.93L1.17,0,6,4.43,10.8,0,8.13,15.93H12l-6,8.4Z",
          fillColor: '#FFC03B',
          fillOpacity: 1,
          strokeWeight: 0,
          scale: 1
      }
  }

    constructor(props)
    {
        super(props)
        this.state = {
            icon: this.icons.black,
            isActive: false,
            zIndex: 1
        }
    }

    componentDidMount()
    {
        
    }

    componentWillReceiveProps(nextProps)
    {
        if(nextProps.isActive)
        {
            console.log('isActive')
            this.setState({
                icon: this.icons.yellow,
                isActive: true,
                zIndex: google.maps.Marker.MAX_ZINDEX + 1
            })
        } else {
            if(this.state.isActive)
            {
                this.setState({
                    icon: this.icons.black,
                    isActive: false,
                    zIndex: google.maps.Marker.MAX_ZINDEX
                })
            }
        }
    }

    onMouseOver = (evt) => {
        this.setState({
            icon: this.icons.yellow,
            zIndex: google.maps.Marker.MAX_ZINDEX + 1
        })

        

        if(this.props.markerOver) this.props.markerOver(evt, this.props.data)
    };


    onMouseOut = (evt) => {
        this.setState({
            icon: this.icons.black,
            zIndex: google.maps.Marker.MAX_ZINDEX
        })

        if(this.props.markerOut) this.props.markerOut()
    };

    doClick = (evt) => {
        this.props.history.push(this.props.data.uri)
    }

  render () {
    
    const {data} = this.props;
    const {map} = this.props;


    /*const onClick = (evt) => {

        console.log(data.title)

        let scroller = document.getElementById('locationScroller');

        let target = document.getElementById(data.slug);
        let offset = target.getBoundingClientRect();

        let scrollTop = !isNaN(Math.abs(parseInt(scroller.style.top))) ? Math.abs(parseInt(scroller.style.top)) : 0

        let top = (offset.top + scrollTop) - 100

        console.log(top, Math.abs(parseInt(scroller.style.top)))


        scroller.style.top = -top + 'px'



    };*/

    

    const onMounted = (ref) => {
        
    }

    

    return (
        <Marker
            ref={onMounted}
            icon={this.state.icon}
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}
            zIndex={this.state.zIndex}
            onClick={this.doClick}
            {...this.props}
        />
    );
    };
}


export default withRouter(CustomMarker);


// WEBPACK FOOTER //
// ./src/js/components/CustomMarker/CustomMarker.jsx